module.exports = __webpack_public_path__ + "static/media/safe-labels.66da9337.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/img/callouts/safe-labels.png
// module id = 1188
// module chunks = 0